'use client';

import { type PropsWithChildren, useRef } from 'react';

import { Provider, StoreInterface, StoreType, initializeStore } from '@/stores/store';

export interface PreloadedStoreInterface {
  initialData?: Partial<Omit<StoreInterface, 'updateData'>>;
}

export default function StoreProvider({
  children,
  ...props
}: PropsWithChildren<PreloadedStoreInterface>) {
  const storeRef = useRef<StoreType>(undefined);

  if (!storeRef.current) {
    storeRef.current = initializeStore(props);
  }

  return <Provider value={storeRef.current}>{children}</Provider>;
}
